<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">
                    {{ $t('guest.earphone.title') }}</div>
                <div class="mainBody">
                    <p style="line-height:0.45rem;"><span class="red">{{ $t('guest.earphone.tips_title') }}</span></p>
                    <p style="line-height:0.45rem;">{{ $t('guest.earphone.step1') }}<br>{{ $t('guest.earphone.tips1') }};
                    </p>
                    <p style="line-height:0.45rem;">{{ $t('guest.earphone.step2') }}<br>{{ $t('guest.earphone.tips2') }}</p>
                    <p style="line-height:0.45rem;">{{ $t('guest.earphone.step3') }}<br>{{ $t('guest.earphone.tips3') }}</p>
                    <img class='preview-img' width='100%' widths="2163" heights="1155"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/earphoneBig_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/earphoneBig_en.png?v=0223'"
                        :links="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/earphoneBig_en.png?v=0223' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2022/maps/earphoneBig_en.png?v=0223'"
                        @click="bigImg"> 
                        <p style="line-height:0.45rem;"><span class="red" style="background: none;color: #f00;padding-right: 0;">{{ $t('guest.earphone.tipss') }}</span></p>
                </div>
            </div>
        </div>
        <div class="back" @click="path('guest')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />

    </div>
</template>
<script>
import menus from "../../components/menu.vue"
import Photo from "../../components/PhotoSwipe.vue"
export default {
    components: {
        menus, Photo
    },
    name: "menuView",
    data () {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
        }
    },
    created () {
        //_hmt.push(['_trackPageview', '/guest/earphone']);

    },
    mounted () {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3 (content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut () {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path (path) {
            this.$router.replace('/' + path)
        },
        bigImg (el) {
            this.items[0].w = el.target.getAttribute('widths');
            this.items[0].h = el.target.getAttribute('heights');
            this.items[0].src = el.target.getAttribute('links');
            this.bigImg_show = true;
        },
        close (e) {
            this.bigImg_show = e;
        },
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/guest/earphone.vue